<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <ul>
                        <li @click="scrollToElement('vn-1')">Cách vào màn hình [Thông tin điểm danh]</li>
                        <li @click="scrollToElement('vn-2')">Tìm kiếm khóa học</li>
                        <li @click="scrollToElement('vn-3')">Xuất danh sách điểm danh</li>
                        <li @click="scrollToElement('vn-4')">Danh sách học viên có mặt</li>
                        <li @click="scrollToElement('vn-5')">Danh sách học viên vắng mặt</li>
                    </ul>
                </div>
                <div id="vn-1">
                    <h1>1. Cách vào màn hình [Thông tin điểm danh]</h1>
                </div>
                <div><img src="/static\images\vi\newManual\manageAttendanceManual-1.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào [Avatar] hoặc [Tên người dùng] để mở menu quản lý dành cho giáo viên.</p>
                    <p>② Khi nhấn vào mục [Thông tin điểm danh ] thì sẽ chuyển đến màn hình [Thông tin điểm danh] gồm tất cả các khóa học online mà giáo viên phụ trách.</p>
                </div>
                <div id="vn-2">
                    <h1>2. Tìm kiếm khóa học</h1>
                </div>
                <div><img src="/static\images\vi\newManual\manageAttendanceManual-2.png" alt="" /></div>
                <div>
                    <p>① Nhập tên khóa học cần tìm kiếm sau đó bấm vào icon search để tiến hành tìm kiếm khóa học</p>
                    <p>② Chọn ngày bắt đầu khóa học cần tìm kiếm sau đó bấm vào icon search để tiến hành tìm kiếm khóa học</p>
                </div>
                <div id="vn-3">
                    <h1>3. Xuất danh sách học viên</h1>
                </div>
                <div><img src="/static\images\vi\newManual\manageAttendanceManual-3.png" alt="" /></div>
                <div>
                    <p>Nhấn nút [Xuất danh sách học viên] để xuất file excel toàn bộ thông tin điểm danh của khóa học</p>
                </div>
                <div id="vn-4">
                    <h1>4. Danh sách học viên có mặt</h1>
                </div>
                <div><img src="/static\images\vi\newManual\manageAttendanceManual-4.png" alt="" /></div>
                <div>
                    <p>Nhập tên học viên cần tìm kiếm</p>
                </div>
                <div id="vn-5">
                    <h1>5. Danh sách học viên vắng mặt</h1>
                </div>
                <div>
                    <p>
                        <b><i>5.1 Tìm kiếm học viên</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageAttendanceManual-5.png" alt="" /></div>
                <div>
                    <p>Nhập tên học viên cần tìm kiếm</p>
                </div>
                <div>
                    <p>
                        <b><i>5.2 Điểm danh học viên</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageAttendanceManual-6.png" alt="" /></div>
                <div>
                    <p>Nhấn vào nút [+] để điểm danh học viên</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <ul>
                        <li @click="scrollToElement('vn-1')">Cách vào màn hình [Thông tin điểm danh]</li>
                        <li @click="scrollToElement('vn-2')">Tìm kiếm khóa học</li>
                        <li @click="scrollToElement('vn-3')">Danh sách học viên có mặt</li>
                        <li @click="scrollToElement('vn-4')">Danh sách học viên vắng mặt</li>
                        <li @click="scrollToElement('vn-5')">Điểm danh giùm học sinh</li>
                    </ul>
                </div>
                <div id="vn-1"><p>1. Cách vào trang thông tin điểm danh.</p></div>
                <div><p>① Click icon Menu ở phía dưới màn hình, thì thanh Menu như trên sẽ xuất hiện từ phía bên trái màn hình.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_course_live_1_1.png" alt="" /></div>
                <div><p>② Nhấn vào ô [Thông tin điểm danh] để di chuyển đến trang thông tin học viên.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_course_live_1_2.png" alt="" /></div>
                <div id="vn-2"><p>2. Tìm kiếm khóa học.</p></div>
                <div><p>① Tìm kiếm khóa học theo tên.</p></div>
                <div><p>② Tìm kiếm khóa học theo ngày.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_course_live_2_1.png" alt="" /></div>
                <div id="vn-3"><p>3. Danh sách học viên có mặt.</p></div>
                <div><p>Hiển thị danh sách học viên có mặt trong khóa đó.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_course_live_3_1.png" alt="" /></div>
                <div id="vn-4"><p>4. Danh sách học viên vắng mặt.</p></div>
                <div><p>Hiển thị danh sách học viên vắng mặt trong khóa đó.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_course_live_4_1.png" alt="" /></div>
                <div id="vn-5"><p>5. Điểm danh giùm học sinh.</p></div>
                <div><p>① Click icon [Điểm danh] học viên cần điểm danh giùm.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_course_live_5_1.png" alt="" /></div>
                <div><p>② Nhấn nút [Ok] để điểm danh.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_course_live_5_2.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                typeLanguage: 3,
            };
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {
            this.typeLanguage = this.$lang();
        },
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/manageAttendance_manual.vue